/* =========================================================
   Blog BETA — per-article comment widget (Q1 sandbox).

   Mounts into [data-blog-comments] on the native Shopify beta article
   page, resolves the article's slug -> blog_posts row, then loads approved
   comments + reactions, renders the SAME .li-* markup the live feed uses (styles
   come from the globally-loaded updates.css), subscribes to Realtime, and posts
   new comments/likes to the blog-worker BETA routes (/comments,
   /reactions). Reuses the global window.MP_BLOG config + supabase-js UMD.

   Isolated from the live feed: blog-data.js early-returns when there is no
   [data-blog-feed] (there isn't on an article page), so there is no overlap.
   ========================================================= */
(function () {
  "use strict";

  var cfg = window.MP_BLOG || {};
  var mounts = document.querySelectorAll("[data-blog-comments]");
  if (!mounts.length) return;
  if (!cfg.supabaseUrl || !cfg.anonKey || !window.supabase) {
    mounts.forEach(function (m) { m.innerHTML = '<p class="up2-noresults">Comments are temporarily unavailable.</p>'; });
    return;
  }

  var WORKER = (cfg.workerUrl || "").replace(/\/$/, "");
  var sb = window.supabase.createClient(cfg.supabaseUrl, cfg.anonKey);
  var visitorId = getVisitor();

  // ── shared pure helpers (mirrors blog-data.js) ──
  function getVisitor() {
    try {
      var v = localStorage.getItem("mp_visitor");
      if (!v) { v = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("mp_visitor", v); }
      return v;
    } catch (e) { return "v_anon"; }
  }
  var USER_ADJ = ["mind","green","black","quantum","neon","cosmic","cyber","violet","lunar","pixel","turbo","hyper","echo","nova","zen","solar","atomic","crimson","golden","silent","electric","wild","frost","shadow","prime","stellar","rogue","mystic","rapid","vivid"];
  var USER_NOUN = ["power","cat","holster","wave","fox","ghost","byte","comet","raven","drift","spark","pilot","nomad","forge","orbit","tiger","falcon","circuit","ember","pulse","vortex","ranger","wolf","phoenix","matrix","badger","otter","hawk","panther","lynx"];
  function makeUsername(seed) {
    var h = 2166136261 >>> 0, src = seed || "anon";
    for (var i = 0; i < src.length; i++) { h ^= src.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    var adj = USER_ADJ[h % USER_ADJ.length], noun = USER_NOUN[(h >>> 8) % USER_NOUN.length], variant = (h >>> 16) % 3;
    if (variant === 0) return adj + noun + "user";
    if (variant === 1) return adj + noun + (((h >>> 20) % 90) + 10);
    return adj + noun;
  }
  function myUsername() { return makeUsername(visitorId); }
  function myInitial() { return (myUsername()[0] || "M").toUpperCase(); }
  function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  function cssEsc(s) { return String(s).replace(/["\\]/g, "\\$&"); }
  function fmtDate(iso) { try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }); } catch (e) { return ""; } }
  function initial(name) { return (String(name || "?").trim()[0] || "?").toUpperCase(); }
  function heartSvg() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10v11"/><path d="M18 21H7V10l4.5-7a2 2 0 0 1 3 1.5V9h4a2 2 0 0 1 2 2.3l-1.3 7A2 2 0 0 1 19 21Z"/></svg>'; }
  function commentSvg() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4L3 21l1.1-4A8.4 8.4 0 1 1 21 11.5Z"/></svg>'; }

  mounts.forEach(initRoot);

  function initRoot(root) {
    var slug = root.getAttribute("data-post-slug");
    if (!slug) return;
    var collapsed = root.hasAttribute("data-collapsed"); // feed cards start collapsed
    var articleUrl = root.getAttribute("data-article-url"); // feed only → "Full post" link

    var post = null;             // { id, title }
    var comments = [];           // [{id,post_id,parent_id,author_name,body,created_at}]
    var seen = {};               // id -> true
    var likeCount = { post: {}, comment: {} };
    var myLike = { post: {}, comment: {} };

    function addReaction(r) {
      var t = r.post_id ? "post" : "comment";
      var id = r.post_id || r.comment_id;
      if (!id) return;
      likeCount[t][id] = (likeCount[t][id] || 0) + 1;
      if (r.visitor_id === visitorId) myLike[t][id] = true;
    }
    function ownsTarget(r) {
      if (r.post_id) return post && r.post_id === post.id;
      if (r.comment_id) return !!seen[r.comment_id];
      return false;
    }

    load();

    async function load() {
      try {
        // Shopify lowercases article handles, but the Supabase slug may be mixed
        // case — match case-insensitively so every card resolves to its post.
        var pr = await sb.from("blog_posts")
          .select("id,title").ilike("slug", slug).eq("status", "published").maybeSingle();
        post = pr.data || null;
        if (!post) { root.innerHTML = ""; return; } // unpublished/preview — no comments UI
        var results = await Promise.all([
          sb.from("blog_comments").select("id,post_id,parent_id,author_name,body,created_at")
            .eq("post_id", post.id).eq("status", "approved").order("created_at", { ascending: true }),
          sb.from("blog_reactions").select("post_id,comment_id,visitor_id"),
        ]);
        (results[0].data || []).forEach(function (c) { seen[c.id] = true; comments.push(c); });
        (results[1].data || []).forEach(function (r) { if (ownsTarget(r)) addReaction(r); });
      } catch (e) {
        root.innerHTML = '<p class="up2-noresults">Couldn’t load comments.</p>';
        return;
      }
      render();
      subscribe();
    }

    // ── markup (mirrors blog-data.js commentItem/composerHtml) ──
    function composerHtml(parentId) {
      return (
        '<form class="li-comment-form' + (parentId ? " li-reply-form" : "") + '" data-comment-form' +
        (parentId ? ' data-parent="' + esc(parentId) + '"' : "") + ">" +
          '<div class="li-comment-composer">' +
            '<span class="li-avatar li-avatar--me" aria-hidden="true">' + esc(myInitial()) + "</span>" +
            '<div class="li-composer-fields">' +
              '<textarea name="body" rows="1" placeholder="' + (parentId ? "Add a reply…" : "Add a comment…") + '" required></textarea>' +
              '<div class="li-comment-fields">' +
                '<span class="li-composer-hint">' + (parentId ? "Replying" : "Posting") + " as <strong>" + esc(myUsername()) + "</strong></span>" +
                '<button type="submit">' + (parentId ? "Reply" : "Post") + "</button>" +
              "</div>" +
              '<p class="li-form-note" hidden></p>' +
            "</div>" +
          "</div>" +
        "</form>"
      );
    }
    function commentItem(c, all) {
      var replies = all.filter(function (x) { return x.parent_id === c.id; });
      var likes = likeCount.comment[c.id] || 0;
      var liked = !!myLike.comment[c.id];
      return (
        '<li class="li-comment" data-comment="' + esc(c.id) + '">' +
          '<span class="li-avatar li-avatar--sm">' + esc(initial(c.author_name)) + "</span>" +
          '<div class="li-comment-bubble">' +
            '<span class="li-comment-head"><strong>' + esc(c.author_name) + '</strong><span class="li-comment-date">' + esc(fmtDate(c.created_at)) + "</span></span>" +
            "<p>" + esc(c.body) + "</p>" +
            '<div class="li-comment-meta">' +
              '<button type="button" class="li-cmeta li-clike' + (liked ? " is-liked" : "") + '" data-like-comment="' + esc(c.id) + '">' + (liked ? "♥" : "♡") + ' <span class="li-clike-count">' + likes + "</span></button>" +
              '<button type="button" class="li-cmeta li-creply" data-reply="' + esc(c.id) + '">Reply</button>' +
            "</div>" +
            '<ul class="li-comment-replies">' + replies.map(function (r) { return commentItem(r, all); }).join("") + "</ul>" +
          "</div>" +
        "</li>"
      );
    }

    function render() {
      var topLevel = comments.filter(function (c) { return !c.parent_id; });
      var likes = likeCount.post[post.id] || 0;
      var liked = !!myLike.post[post.id];
      root.innerHTML =
        '<div class="li-actions">' +
          '<button type="button" class="li-act li-like' + (liked ? " is-liked" : "") + '" data-like-post="' + esc(post.id) + '" aria-pressed="' + (liked ? "true" : "false") + '">' +
            heartSvg() + '<span class="li-like-count">' + likes + '</span><span class="li-act-label">Like</span></button>' +
          '<button type="button" class="li-act li-comment-btn" data-comment-toggle aria-expanded="' + (collapsed ? "false" : "true") + '">' + commentSvg() + '<span class="li-comment-count">' + comments.length + '</span><span class="li-act-label">Comment</span></button>' +
          (articleUrl ? '<a class="li-act li-fullpost" href="' + esc(articleUrl) + '" style="margin-left:auto">' + '<span class="li-act-label">Full post</span> <span aria-hidden="true">→</span></a>' : "") +
        "</div>" +
        '<div class="li-comments" data-comments' + (collapsed ? " hidden" : "") + ">" +
          composerHtml(null) +
          '<ul class="li-comment-list" data-comments-list>' +
            topLevel.map(function (c) { return commentItem(c, comments); }).join("") +
          "</ul>" +
        "</div>";
    }

    function updateLikeUI(type, id) {
      var liked = !!myLike[type][id], count = likeCount[type][id] || 0;
      if (type === "post") {
        var btn = root.querySelector('[data-like-post="' + cssEsc(id) + '"]');
        if (btn) { btn.classList.toggle("is-liked", liked); btn.setAttribute("aria-pressed", liked ? "true" : "false");
          var cnt = btn.querySelector(".li-like-count"); if (cnt) cnt.textContent = count; }
      } else {
        var cbtn = root.querySelector('[data-like-comment="' + cssEsc(id) + '"]');
        if (cbtn) { cbtn.classList.toggle("is-liked", liked); cbtn.firstChild.textContent = liked ? "♥ " : "♡ ";
          var ccnt = cbtn.querySelector(".li-clike-count"); if (ccnt) ccnt.textContent = count; }
      }
    }

    function addComment(c) {
      if (!c || seen[c.id] || c.post_id !== post.id) return;
      if (c.status && c.status !== "approved") return;
      seen[c.id] = true;
      comments.push(c);
      var list = root.querySelector("[data-comments-list]");
      if (!list) return;
      if (c.parent_id) {
        var parentLi = list.querySelector('[data-comment="' + cssEsc(c.parent_id) + '"]');
        if (parentLi) {
          var ul = parentLi.querySelector(":scope > .li-comment-bubble > .li-comment-replies");
          if (ul) ul.insertAdjacentHTML("beforeend", commentItem(c, comments));
        }
      } else {
        list.insertAdjacentHTML("beforeend", commentItem(c, comments));
      }
      var cnt = root.querySelector(".li-comment-count");
      if (cnt) cnt.textContent = String(comments.length);
    }

    // ── interactions (scoped to this widget) ──
    root.addEventListener("click", function (e) {
      var t = e.target;
      var ctoggle = t.closest && t.closest("[data-comment-toggle]");
      if (ctoggle && root.contains(ctoggle)) {
        var box = root.querySelector("[data-comments]");
        if (box) {
          var willOpen = box.hasAttribute("hidden");
          if (willOpen) { box.removeAttribute("hidden"); var ta = box.querySelector("textarea"); if (ta) setTimeout(function () { ta.focus(); }, 50); }
          else box.setAttribute("hidden", "");
          ctoggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        }
        return;
      }
      var likePost = t.closest && t.closest("[data-like-post]");
      if (likePost && root.contains(likePost)) { react("post", likePost.getAttribute("data-like-post")); return; }
      var likeComment = t.closest && t.closest("[data-like-comment]");
      if (likeComment && root.contains(likeComment)) { react("comment", likeComment.getAttribute("data-like-comment")); return; }
      var reply = t.closest && t.closest("[data-reply]");
      if (reply && root.contains(reply)) {
        var li = reply.closest(".li-comment");
        var existing = li.querySelector(":scope > .li-comment-bubble > .li-reply-form");
        if (existing) {
          existing.hidden = !existing.hidden;
          if (!existing.hidden) existing.querySelector("textarea").focus();
          reply.textContent = existing.hidden ? "Reply" : "Cancel";
        } else {
          var bubble = li.querySelector(":scope > .li-comment-bubble");
          bubble.insertAdjacentHTML("beforeend", composerHtml(li.getAttribute("data-comment")));
          bubble.querySelector(".li-reply-form textarea").focus();
          reply.textContent = "Cancel";
        }
        return;
      }
    });

    root.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.matches || !form.matches("[data-comment-form]")) return;
      e.preventDefault();
      submitComment(form);
    });

    async function submitComment(form) {
      var parentId = form.getAttribute("data-parent") || null;
      var body = ((form.querySelector('[name="body"]') || {}).value || "").trim();
      var note = form.querySelector(".li-form-note");
      if (!body) { if (note) { note.hidden = false; note.textContent = "Write a comment first."; } return; }
      try {
        var res = await fetch(WORKER + "/comments", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ post_id: post.id, parent_id: parentId, body: body, visitor_id: visitorId }),
        });
        var j = await res.json();
        if (!res.ok) { if (note) { note.hidden = false; note.textContent = j.error || "Could not post."; } return; }
        form.reset();
        if (j.comment && j.comment.status === "approved") addComment(j.comment);
        else if (note) { note.hidden = false; note.textContent = "Thanks — your comment is pending review."; }
      } catch (e2) { if (note) { note.hidden = false; note.textContent = "Network error."; } }
    }

    async function react(type, id) {
      var liked = !myLike[type][id];
      myLike[type][id] = liked;
      likeCount[type][id] = Math.max(0, (likeCount[type][id] || 0) + (liked ? 1 : -1));
      updateLikeUI(type, id);
      try {
        var payload = { visitor_id: visitorId };
        payload[type === "post" ? "post_id" : "comment_id"] = id;
        var res = await fetch(WORKER + "/reactions", {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
        });
        var j = await res.json();
        if (res.ok) { likeCount[type][id] = j.likes; myLike[type][id] = j.liked; updateLikeUI(type, id); }
      } catch (e) {}
    }

    function bump(r, delta) {
      if (!r || !ownsTarget(r)) return;
      var type = r.post_id ? "post" : "comment";
      var id = r.post_id || r.comment_id;
      if (r.visitor_id === visitorId) return;
      likeCount[type][id] = Math.max(0, (likeCount[type][id] || 0) + delta);
      updateLikeUI(type, id);
    }

    function subscribe() {
      sb.channel("blog-" + slug)
        .on("postgres_changes", { event: "INSERT", schema: "public", table: "blog_comments", filter: "post_id=eq." + post.id }, function (p) { addComment(p.new); })
        .on("postgres_changes", { event: "UPDATE", schema: "public", table: "blog_comments", filter: "post_id=eq." + post.id }, function (p) { addComment(p.new); })
        .on("postgres_changes", { event: "INSERT", schema: "public", table: "blog_reactions" }, function (p) { bump(p.new, +1); })
        .on("postgres_changes", { event: "DELETE", schema: "public", table: "blog_reactions" }, function (p) { bump(p.old, -1); })
        .subscribe();
    }
  }
})();
